import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  FILTER_COAT,
  FILTER_COLOR,
  FILTER_GENDER,
  FILTER_HEALTH_TIER_LEVELS,
  FILTER_POSTAL_CODE,
  FILTER_SIZE
} from 'dpl/constants/query_params';

export default function useStickyFilters({ container } = {}) {
  const [stuck, setStuck] = useState(false);

  function scrollToContainerParentTop() {
    // Scroll to 1px below the container's parent top
    // to make sure that the exposed filters remain stuck.
    container.parentElement.style.scrollMarginTop = '-1px';
    container.parentElement.scrollIntoView();
  }

  const { postalCode, size, color, coat, gender, healthTesting } = useSelector(
    ({ queryParams }) => ({
      postalCode: queryParams[FILTER_POSTAL_CODE],
      size: queryParams[FILTER_SIZE],
      color: queryParams[FILTER_COLOR],
      coat: queryParams[FILTER_COAT],
      gender: queryParams[FILTER_GENDER],
      healthTesting: queryParams[FILTER_HEALTH_TIER_LEVELS]
    })
  );

  useEffect(() => {
    // Ensure that exposed filters remain stuck after filtering
    // in cases where few or no results are rendered by scrolling
    // the window back to the top of the container's parent.
    if (stuck) scrollToContainerParentTop();
  }, [postalCode, size, color, coat, gender, healthTesting]);

  useEffect(() => {
    if (!('IntersectionObserver' in window)) return null;
    if (!container) return null;

    const observer = new window.IntersectionObserver(
      ([e]) => setStuck(e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(container);

    return () => {
      observer.unobserve(container);
    };
  }, [container]);

  return { stuck };
}
